<div class="header-bar">
  <div class="header-left"></div>
  <div class="header-center">
    <ng-container *ngIf="newFlow">Create {{ internal ? 'Internal Flow' : 'Flow' }}</ng-container
    ><ng-container *ngIf="!newFlow">
      <div class="flow-name">Edit {{ internal ? 'Internal Flow' : 'Flow' }}</div>
    </ng-container>
  </div>
  <div class="header-right">
    <button
      *ngIf="!(mode.inNodeConnectionMode || mode.inNodeAddMode)"
      mat-button
      color="lightGreen"
      (click)="saveFlow()"
      [disabled]="flowSaveDisabled"
    >
      Save Flow
    </button>
    <button
      *ngIf="mode.inNodeConnectionMode"
      mat-button
      color="warn"
      (click)="cancelConnection()"
    >
      Cancel
    </button>
    <button
      *ngIf="mode.inNodeAddMode"
      mat-button
      color="warn"
      (click)="cancelNodeAdd()"
    >
      Cancel
    </button>
  </div>
</div>

<div #flow class="flow">
  <div class="flow-sidebar">
    <div class="container flow-items-container">
      <div
        *ngFor="let item of sidebarItems"
        class="item"
        [ngClass]="{
          disabled: item.disabledFn
            ? item.disabledFn()
            : item.disabled || sidebarDisabled
        }"
        (click)="onSidebarItemClick(item)"
      >
        <svg-icon
          [src]="item.icon"
          svgClass="{{
            item.selected
              ? 'lightBlue'
              : item.code === 'starter'
              ? 'lightGreen'
              : 'fiord'
          }}"
        ></svg-icon>
      </div>
    </div>
    <div class="zoom-options">
      <div class="zoom-btn zoom-in-btn" (click)="center()">
        <svg-icon src="assets/svg/flows/center.svg"></svg-icon>
      </div>
      <div class="zoom-btn zoom-in-btn" (click)="zoomIn()">
        <svg-icon src="assets/svg/flows/zoomin.svg"></svg-icon>
      </div>
      <div class="zoom-btn zoom-out-btn" (click)="zoomOut()">
        <svg-icon src="assets/svg/flows/zoomout.svg"></svg-icon>
      </div>
    </div>
  </div>

  <div
    id="flow-builder-area"
    class="flow-builder-area"
    [ngStyle]="{ cursor: currentCursor ? currentCursor : 'default' }"
    (click)="onFlowBuilderAreaClicked($event)"
    (mousedown)="onMouseDown($event)"
    (mouseup)="onMouseUpOrLeave($event)"
    (mousemove)="onMouseMove($event)"
    (mouseleave)="onMouseUpOrLeave($event)"
  >
    <div #panzoomArea id="panzoom-area" class="panzoom-area">
      <ng-template #nodes></ng-template>
    </div>

    <div class="flow-menu-area">
      <ng-template #flowMenu></ng-template>
    </div>
  </div>

  <div [hidden]="true" #menuShadow class="node-menu-shadow">
    <svg height="100%" width="100%">
      <polygon style="fill: rgb(209, 213, 223)" />
      Sorry, your browser does not support inline SVG.
    </svg>
  </div>
</div>
